"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectBetweenPwhSupplyAndHtgCc = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _Connector = require("./Connector");
var _constants = require("../../../utils/constants");
var _useGetComponentsByParams = require("../../../hooks/store/useGetComponentsByParams");
var _selectors = require("../../../redux/selectors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @todo make separate file */
const ItemConnector = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    HtgCcLength = 0,
    index = 0,
    id
  } = _ref;
  const type = _constants.TypesByDep.PwhSupply;
  const {
    thingPwhSupplyDeviceType: {
      id: pwhSupTypeKey = -1
    } = {}
  } = (0, _useGetComponentsByParams.useGetComponentByTypeAndId)({
    type,
    id
  }) || {};
  const isKey = key => Number(pwhSupTypeKey) === key;
  return /*#__PURE__*/_react.default.createElement(_Connector.Connector, {
    position: [-index * _constants.spaseBetweenModelsByCol, 0, 0],
    pipes: [{
      highlightsType: isKey(_constants.pwhSupConfig.storeCharging) ? _constants.pipesTypes.chilledWater : _constants.pipesTypes.heatingReturn,
      display: true
    }, {
      highlightsType: isKey(_constants.pwhSupConfig.storeCharging) ? _constants.pipesTypes.hotWater : _constants.pipesTypes.heatingFlow,
      display: true
    }],
    connectWithPrevious: index > 0 && HtgCcLength <= 1,
    connectTo: HtgCcLength > 1 ? _constants.ConnectTo.null : _constants.ConnectTo.left,
    isSecondConnect: index === 1,
    index: index
  });
});
const ConnectBetweenPwhSupplyAndHtgCc = exports.ConnectBetweenPwhSupplyAndHtgCc = /*#__PURE__*/(0, _react.memo)(() => {
  const type = _constants.TypesByDep.PwhSupply;
  const modelPosition = (0, _reactRedux.useSelector)((0, _selectors.selectStructurePositionsByType)(_constants.TypesConnect.ConnectFromHtgCcToPwhSupply));
  const HtgCcLength = (0, _useGetComponentsByParams.useGetComponentsIdByDepAndByType)({
    type: _constants.TypesByDep.HtgCc
  }).length;
  const {
    idList = [],
    isSerial = false
  } = (0, _useGetComponentsByParams.useGetComponentsByDepAndByType)({
    type
  });
  if (!idList.length) return null;
  const ids = isSerial ? [idList[0]] : idList;
  return /*#__PURE__*/_react.default.createElement("group", {
    dispose: null,
    position: modelPosition
  }, ids.map((id, index) => /*#__PURE__*/_react.default.createElement(ItemConnector, {
    key: id,
    index: index,
    HtgCcLength: HtgCcLength,
    id: id
  })));
});